<template>
    <div class="container-fluid w-100 h-100" style="overflow-x: hidden">
        <navbar :title="$t('menu.work_report')" class="mb-1"/>
        <search-filter :user="user" @search="fetchWorkReports"/>
        <work-report-list
          v-if="!detailsMode"
          class="my-2"
          :results="results"
          @details="showReportDetails"
        />
        <base-modal v-if="detailsMode" hide-footer @close="detailsMode = false" size="lg">
            <work-report-details
              v-if="detailsMode"
              id="details"
              ref="details"
              :report-details="reportDetails"
            />
        </base-modal>
        <div
          v-if="loading"
          id="loader"
          class="spinner"
        />
  </div>
</template>

<script>
import SearchFilter from '../search/SearchFilter'
import WorkReportList from './WorkReportList'
import WorkReportDetails from './WorkReportDetails'
import {restApi} from '../mixins/RestApiMixin'
import Navbar from "@/components/utils/Navbar";
import BaseModal from "@/components/BaseModal";

export default {
    name: 'WorkReports',
    components: {BaseModal, Navbar, WorkReportList, SearchFilter, WorkReportDetails},
    mixins: [restApi],
    props: {
        user: {
            type: Object,
            default: null
        }
    },
    data: function () {
        return {
            loading: false,
            results: [],
            detailsMode: false,
            reportDetails: null
        }
    },
    methods: {
        fetchWorkReports: function (params) {
            if (params) {
                this.loading = true
                this.restFetchParams(this.workReportUrl, params, this.handleResponse)
            }
        },
        handleResponse: function (response) {
            if (response) {
                this.results = response.data
            }
            this.loading = false
        },
        showReportDetails: function (details) {
            this.reportDetails = details
            this.detailsMode = true
        },
        showReportsList: function () {
            this.detailsMode = false
        },
        print: function () {
            this.$refs.details.print()
        }
    }
}
</script>
